import React from 'react'
import { getFileIcon, formatFileSize } from './attachment-utils'

interface FileAttachmentCardProps {
  attachment: {
    id: string
    url: string
    filename?: string
    mime_type?: string
    size?: number
    metadata?: { type?: string }
  }
  isFromMe: boolean
}

const FileAttachmentCard: React.FC<FileAttachmentCardProps> = ({
  attachment,
  isFromMe,
}) => {
  return (
    <div
      className="d-flex align-items-center p-3 rounded-xl"
      style={{
        color: 'inherit',
        background: isFromMe ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
        border: `1px solid ${
          isFromMe ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)'
        }`,
        minWidth: '240px',
        maxWidth: '320px',
      }}
    >
      <div
        className="d-flex align-items-center justify-content-center rounded-circle me-3"
        style={{
          width: '40px',
          height: '40px',
          backgroundColor: '#007bff',
          color: 'white',
          flexShrink: 0,
        }}
      >
        <ion-icon
          name={getFileIcon(
            attachment.mime_type || '',
            attachment.filename || '',
            attachment.metadata
          )}
          style={{ fontSize: '20px' }}
        />
      </div>
      <div className="flex-grow-1 min-w-0">
        <div
          className="text-truncate"
          style={{
            fontSize: '14px',
            fontWeight: '600',
            marginBottom: '2px',
          }}
        >
          {attachment.filename || 'File'}
        </div>
        {attachment.size && (
          <div
            className="d-flex align-items-center"
            style={{ fontSize: '11px', opacity: 0.7 }}
          >
            <span className="badge bg-primary bg-opacity-75">
              {formatFileSize(attachment.size)}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default FileAttachmentCard
